import MedicationLogDetailedView from "app/screens/residents/show/MedicationLogDetailedView";

export default function MedicationLogPage() {
  return <MedicationLogDetailedView />;
}
